import { useEffect, useState } from 'react';
import { api, type BrandOption } from '@/services/api';
import type { Audience, Category } from '@/types/domain';

export function useBrandOptions(audience: Audience, category: Category) {
  const [brands, setBrands] = useState<BrandOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    api
      .listBrandsFor(audience, category)
      .then((res) => {
        if (cancelled) return;
        if (res.success) {
          setBrands(res.data);
        } else {
          setError(res.message);
        }
      })
      .catch(() => {
        if (!cancelled) setError('Could not load brands right now. Please try again.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [audience, category]);

  return { brands, loading, error };
}
